import { z } from 'zod';

import { CursorPaginationMetaSchema, PaginationSchema } from '../../../pagination.js';

export const ListPlatformUsersQuerySchema = PaginationSchema.extend({
  q: z.string().optional(),
  organizationId: z.uuid().optional(),
});

export type ListPlatformUsersQuery = z.infer<typeof ListPlatformUsersQuerySchema>;

export const PlatformUserListItemSchema = z.object({
  userId: z.uuid().nullable(),
  inviteId: z.uuid().nullable(),
  email: z.email(),
  fullName: z.string(),
  status: z.enum(['invited', 'active', 'inactive', 'blocked']),
  organizationId: z.uuid(),
  organizationName: z.string(),
  scopeType: z.enum(['TENANT', 'PLACE']),
  profileName: z.string(),
  placeName: z.string().nullable(),
});

export type PlatformUserListItem = z.infer<typeof PlatformUserListItemSchema>;

export const ListPlatformUsersResponseSchema = z.object({
  items: z.array(PlatformUserListItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListPlatformUsersResponse = z.infer<typeof ListPlatformUsersResponseSchema>;
